const type = 'SET_CUSTOMER_PARAMS_LOADING';

const setCustomerParamsLoading = (payload) => ({
  type,
  payload,
});

export { type };
export default setCustomerParamsLoading;
